import { Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { SyncfusionService } from 'src/app/services/syncfusion.service';
import { grandTotalsRow, PivotViewComponent, ToolbarItems, ToolbarService } from '@syncfusion/ej2-angular-pivotview';
import { select } from '@syncfusion/ej2-base';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-pivot-table-molecule',
  providers: [ToolbarService],
  templateUrl: './pivot-table-molecule.component.html',
  styleUrls: ['./pivot-table-molecule.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PivotTableMoleculeComponent {
  @Input() rowCollection: any;
  @Input() rowField: any;
  @Input() columnCollection: any;
  @Input() columnField: any;
  @Input() rowFilters: any;
  @Input() pivotId: string;
  @ViewChild('pivotview', { static: false }) pivotObj: PivotViewComponent | undefined;
  public dataSourceSettings: any;
  public toolbarOptions: ToolbarItems[] = ['Export'];
  gridData: any = [];
  isLoading: boolean = false;

  constructor(private syncfusionService: SyncfusionService, private snack: MatSnackBar,) { }
  ngOnInit(): void {
    this.getPivotData();
  }
  showSnackbar(message: string) {
    this.snack.open(message, 'close', {
      duration: 4000,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  getPivotData() {
    this.isLoading = true;
    const payload = {
      rowCollection: this.rowCollection,
      rowField: this.rowField,
      columnCollection: this.columnCollection,
      columnField: this.columnField,
      rowFilters: this.rowFilters
    };

    this.syncfusionService?.getInventoryPivotData(payload).subscribe((response:any)=>{
      this.gridData = response;
      this.gridData = this.gridData?.map((item: any) => {
        return {
          ...item,
          row: item?.row?.toUpperCase(),
        };
      });
      this.dataSourceSettings = {
        dataSource: this.gridData,
        rows: [{ name: 'row', caption: 'Brand' }],
        columns: [{ name: 'column' }],
        values: [{ name: 'inventory' }],
        toolbar: ['Excel', 'Csv'],
        actionBegin: (args) => {
          if (args.requestType === 'toolbarItemClick') {
            if (args.item.id === 'PivotGrid_Excel') {
              this.pivotObj.excelExport();
            }
            if (args.item.id === 'PivotGrid_Csv') {
              this.pivotObj.csvExport();
            }
          }
        }
      }
      this.pivotObj?.refresh();
      this.isLoading = false;
    },(error)=>{
      this.showSnackbar("Failed to aggregate inventory data, retry after sometime");
      this.isLoading = false;
    });
  }
  dataBound(args: any) {
    if(this.pivotObj){
      let pivotID = this.pivotId;
      let exportMenu = select('#' + pivotID + 'export_menu', this.pivotObj.element).ej2_instances[0];
      exportMenu.beforeItemRender = function (args: any) {
        if (args.element.id == pivotID + "pdf") {
          args.element.style.display = "none";
        }
      }
    }
  }
}
